// src/components/VideoComponent.js
import React, { useRef, useState } from "react";
import styles from "../style/VideoComponent.module.css";
import { useTranslation } from "react-i18next";

const VideoComponent = ({ autoplay = false }) => {
  const { t } = useTranslation();
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = !video.muted;
    setIsMuted(video.muted);
    if (!video.muted) {
      video.play().catch(() => {});
    }
  };

  // Welcome page: self-hosted PORTRAIT MP4 with muted autoplay + loop,
  // plus a tap-to-unmute button (browsers only allow autoplay when muted).
  if (autoplay) {
    return (
      <div className={styles.videoContainerWelcome}>
        <div
          className={styles.videoWelcomeWrapper}
          style={{ cursor: "pointer" }}
          onClick={toggleMute}
        >
          <video
            ref={videoRef}
            className={styles.videoPortrait}
            src="/welcome.mp4"
            autoPlay
            muted
            loop
            playsInline
            controls={false}
          />
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              toggleMute();
            }}
            aria-label={isMuted ? t("Unmute") : t("Mute")}
            style={{
              position: "absolute",
              bottom: "12px",
              right: "12px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              padding: 0,
            }}
          >
            {isMuted ? (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11 5L6 9H2v6h4l5 4V5z" fill="#fff" />
                <path
                  d="M23 9l-6 6M17 9l6 6"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            ) : (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11 5L6 9H2v6h4l5 4V5z" fill="#fff" />
                <path
                  d="M15.5 8.5a5 5 0 010 7M19 5a9 9 0 010 14"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </button>
        </div>
      </div>
    );
  }

  // Home page: unchanged YouTube embed.
  const videoId = "6yUimILIVpg";
  return (
    <div className={styles.videoContainer}>
      <div className={styles.videoResponsive}>
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          title="Promotional Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className={styles.videoIframe}
        ></iframe>
      </div>
    </div>
  );
};

export default VideoComponent;
